import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { useCalendar } from '../providers/UserDataProvider';
import ScheduleView from '../components/ScheduleView';
import { useFeatureAccess } from '../hooks/useFeatureAccess';

const MessageWrapper = styled(Paper)(({ theme }) => ({
  margin: theme.spacing(2),
  padding: theme.spacing(5),
  backgroundColor: theme.palette.grey[80],
  color: theme.palette.grey[100],
  display: 'flex',
  borderRadius: theme.spacing(2),
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
}));

/**
 * Calendar Page
 * 
 * Displays the user's social media calendar as a standalone page
 * Uses the same calendar component as the dashboard
 * 
 * @component
 */
const CalendarPage = () => {
  const { events, loading, error } = useCalendar();
  const { canCreatePosts } = useFeatureAccess();

  const handleEventClick = (event) => {
    // TODO: Implement event click handling
    console.log('Event clicked:', event);
  };

  const handleNavigate = (date) => {
    // TODO: Implement navigation handling
    console.log('Navigate to:', date);
  };

  const getWelcomeMessage = () => {
    if (!canCreatePosts) {
      return (
        <Typography variant="h5">
          Post creation is not available in your current plan.
          <Link to="/pricing">Upgrade</Link> to access the calendar and post scheduling features.
        </Typography>
      );
    }

    return (
      <Typography variant="h5">
        Welcome to Solo Social! Contact support if you need help getting started.
      </Typography>
    );
  };

  if (loading) {
    return (
      <Box sx={{ p: 3, flexGrow: 1 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Calendar
        </Typography>
        <Paper sx={{ p: 3 }}>
          <Typography>Loading calendar...</Typography>
        </Paper>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3, flexGrow: 1 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Calendar
        </Typography>
        <Paper sx={{ p: 3 }}>
          <Typography color="error">Error loading calendar: {error.message}</Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, flexGrow: 1 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Calendar
      </Typography>
      
      {canCreatePosts ? (
        <Box>
          <ScheduleView
            posts={events}
            onPostClick={handleEventClick}
            onFetchPosts={handleNavigate}
            loading={loading}
          />
        </Box>
      ) : (
        <MessageWrapper>
          {getWelcomeMessage()}
        </MessageWrapper>
      )}
    </Box>
  );
};

export default CalendarPage; 